import React, { useMemo } from "react";
import "./AllProducts.css";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import AllProductsHero from "../../components/pages/AllProducts/AllProductsHero/AllProductsHero";
import AllProductsExplore from "../../components/pages/AllProducts/AllProductsExplore/AllProductsExplore";
import Hospitality from "../../components/pages/Home/Hospitality/Hospitality";
import AboutStartNewProject from "../../components/pages/About/AboutStartNewProject/AboutStartNewProject";
import { useTranslation } from "react-i18next";
import {
  findPageSection,
  getAboutStartNewProjectContent,
  unwrapSectionData,
} from "../../utils/aboutStartNewProjectSection";
import { usePageContent, usePageContentAliases } from "../../hooks/usePublicQueries";

const PRODUCTS_PAGE_ALIASES = ["allproducts", "all-products", "products", "allproduct"];

const AllProducts = () => {
  const { i18n } = useTranslation();
  const { data: pageContent } = usePageContentAliases(PRODUCTS_PAGE_ALIASES, i18n.language);
  const { data: aboutContent } = usePageContent("about", i18n.language);
  const { data: homeContent } = usePageContent("home", i18n.language);

  const heroSection = useMemo(
    () =>
      findPageSection(pageContent, "hero") ||
      findPageSection(pageContent, "allproductshero") ||
      findPageSection(pageContent, "allproducts"),
    [pageContent]
  );
  const exploreSection = useMemo(
    () =>
      findPageSection(pageContent, "explore") ||
      findPageSection(pageContent, "allproductsexplore") ||
      findPageSection(pageContent, "ourproducts") ||
      findPageSection(pageContent, "otherproducts"),
    [pageContent]
  );
  const hospitalitySection = useMemo(
    () => findPageSection(homeContent, "hospitality"),
    [homeContent]
  );

  return (
    <div className="products-page">
      <div className="products-page-content-guide">
        <Navbar theme="dark" />
        <AllProductsHero content={unwrapSectionData(heroSection)} />
        <AllProductsExplore content={unwrapSectionData(exploreSection)} />
        <Hospitality content={unwrapSectionData(hospitalitySection)} />
        <AboutStartNewProject content={getAboutStartNewProjectContent(aboutContent)} />
      </div>
      <Footer />
    </div>
  );
};

export default AllProducts;
